<!-- <select (change)="paperSelectionChange($event)">
    <option value="all">Overall</option>
    <option *ngFor="let paper of OverallpaperUtility.paperDropdownList;let i = index" [value]="paper?.id">{{'paper-'+(i+1)}}</option>
</select> -->
<ng-container *ngIf="OverallpaperUtility.paperDropdownList?.length >1">
    <mat-select (selectionChange)="paperSelectionChange($event)" [(ngModel)]="OverallpaperUtility.selectedReportPaper"
        class="UNFAPP-overall-drpdown" [disableOptionCentering]="true" panelClass="UNFAPP-overall-drpdownlist">
        <mat-option value="all" selected>Overall</mat-option>
        <mat-option class="text-capitalize" *ngFor="let paper of OverallpaperUtility.paperDropdownList;let i = index"
            [value]="paper?.id">{{'paper-'+(i+1)}}</mat-option>
    </mat-select>
</ng-container>